import { render, staticRenderFns } from "./form.vue?vue&type=template&id=6edf8908&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./form.vue?vue&type=style&index=1&id=6edf8908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edf8908",
  null
  
)

export default component.exports